import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';

import { APP_CONFIG, AUTH_METHOD, IAppConfig, PATH_WHITELIST } from '@recruitee/common';
import { HttpApiErrorHandlerService, HttpApiService } from '@recruitee/http';
import { IntegrationsCredentials } from '@recruitee/integrations-types';

import { IntegrationHttpApiRequestOptions, IntegrationsHttpRequestData } from './types';

@Injectable({
  providedIn: 'root',
})
export class IntegrationsHttpApiService extends HttpApiService {
  constructor(
    http: HttpClient,
    httpRequestData: IntegrationsHttpRequestData,
    errorHandlerService: HttpApiErrorHandlerService,
    integrationsCredentials: IntegrationsCredentials,
    @Inject(AUTH_METHOD) authMethod: string,
    @Inject(APP_CONFIG) appConfigData: IAppConfig,
    @Inject(PATH_WHITELIST) @Optional() pathWhitelist?: string[],
  ) {
    super(
      http,
      httpRequestData,
      errorHandlerService,
      integrationsCredentials.accessToken,
      integrationsCredentials.companyId,
      authMethod,
      appConfigData,
      pathWhitelist,
    );
  }

  public get<R = any>(
    path: string,
    params?: any,
    options?: IntegrationHttpApiRequestOptions,
  ): Observable<R> {
    return super.get(path, params, options);
  }

  public post<R = any>(
    path: string,
    params?: any,
    body?: object | null,
    options?: IntegrationHttpApiRequestOptions,
    progressEmitter: string | null = null,
  ): Observable<R> {
    return super.post(path, params, body, options, progressEmitter);
  }

  public put<R = any>(
    path: string,
    params?: any,
    body?: object,
    options?: IntegrationHttpApiRequestOptions,
  ): Observable<R> {
    return super.put(path, params, body, options);
  }

  public patch<R = any>(
    path: string,
    params?: any,
    body?: object | null,
    options?: IntegrationHttpApiRequestOptions,
  ): Observable<R> {
    return super.patch(path, params, body, options);
  }

  public delete<R = any>(
    path: string,
    params?: any,
    options?: IntegrationHttpApiRequestOptions,
  ): Observable<R> {
    return super.delete(path, params, options);
  }
}
